/**
 * Initial state
 */
const initialState = {
    isOpen: true
};

/**
 * Sidebar reducer
 */
export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case 'SIDEBAR_RESET':
            return initialState;
        case 'SIDEBAR_SHOW': {
            return {
                ...state,
                isOpen: payload,
            }
        }
        case 'SIDEBAR_HIDE': {
            return {
                ...state,
                isOpen: payload,
            }
        }
        default:
            break;
    }

    return state
}


// WEBPACK FOOTER //
// ./src/reducers/sidebar.js